import { render, staticRenderFns } from "./DeleteCampus.vue?vue&type=template&id=89118a52&scoped=true&"
import script from "./DeleteCampus.vue?vue&type=script&lang=js&"
export * from "./DeleteCampus.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCampus.vue?vue&type=style&index=0&id=89118a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89118a52",
  null
  
)

component.options.__file = "DeleteCampus.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VSnackbar,
})
